module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-form"
  }, [_c('el-form', {
    staticClass: "content-form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('p', {
    staticClass: "package-name"
  }, [_vm._v(_vm._s(_vm.product.name) + "   " + _vm._s(_vm.product.price) + " 元/年")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐内容"
    }
  }, [_c('ul', {
    staticClass: "package-details"
  }, [_c('li', [_c('span', [_vm._v("项目额度")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.product.permanent ? ((_vm.product.permanent) + " 个") : '不限个数'))])]), _vm._v(" "), (_vm.product.sub_account) ? _c('li', [_c('span', [_vm._v("子账号")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.product.sub_account) + " 个")])]) : _vm._e(), _vm._v(" "), (!_vm.product.logo) ? _c('li', [_c('span', [_vm._v("自定义加载页")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("免费")])]) : _vm._e(), _vm._v(" "), (!_vm.product.export) ? _c('li', [_c('span', [_vm._v("导出")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("免费")])]) : _vm._e(), _vm._v(" "), (_vm.product.custom_cs) ? _c('li', [_c('span', [_vm._v("企业专属服务")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "target-intro"
  }, [_vm._v(_vm._s(_vm.product.target_intro))])])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1), _vm._v(" "), (_vm.product.price > 1000) ? _c('a', {
    staticClass: "info contactUs",
    on: {
      "click": _vm.$contactMarket
    }
  }, [_vm._v("\n            联系销售\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('promoteCode')
    },
    attrs: {
      "label": "优惠码（选填）"
    }
  }, [_c('el-input', {
    staticClass: "promteInput",
    on: {
      "blur": _vm.checkPrice
    },
    model: {
      value: (_vm.promoteCode),
      callback: function($$v) {
        _vm.promoteCode = $$v
      },
      expression: "promoteCode"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.checkPrice
    },
    slot: "append"
  }, [_vm._v("\n            使用\n          ")])], 1), _vm._v(" "), (!_vm.priceChecking && _vm.promoteDescription) ? _c('span', {
    staticClass: "promoteDescription"
  }, [_c('i', {
    staticClass: "ppj-icon-ok"
  }), _vm._v(_vm._s(_vm.promoteDescription) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('promoteCode')))])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "price"
  }, [_vm._v("应付金额："), _c('span', {
    staticClass: "actualPrice"
  }, [_vm._v(_vm._s(_vm.actualPrice))]), _vm._v(" 元\n          "), (_vm.actualPrice !== _vm.originalPrice) ? _c('span', {
    staticClass: "sub-price"
  }, [_vm._v("\n            订单总额：" + _vm._s(_vm.originalPrice) + " 元   优惠：" + _vm._s(_vm.discount) + " 元\n        ")]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header"
  }, [_c('p', [_vm._v("确认订单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a766ad86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/index.vue
// module id = 941
// module chunks = 3